import { render } from "./AppFooterNav.vue?vue&type=template&id=4476c7fe&scoped=true&ts=true"
import script from "./AppFooterNav.vue?vue&type=script&lang=ts"
export * from "./AppFooterNav.vue?vue&type=script&lang=ts"

import "./AppFooterNav.vue?vue&type=style&index=0&id=4476c7fe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4476c7fe"]])

export default __exports__